import { useState } from "react";

const formatAUD = (value) =>
    new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 2
    }).format(value);


const buildStateSummary = (dues, centers) => {
    return dues.reduce((acc, item) => {
        const centerInfo = centers.find(
            (c) => item.center === c.name || item.center === c.invoiceName
        );
        const state = centerInfo ? centerInfo.city : "Unknown";

        if (!acc[state]) {
            acc[state] = { total: 0, centers: [] };
        }

        acc[state].total += item.total;
        acc[state].centers.push({
            name: item.center,
            total: item.total
        });

        return acc;
    }, {});
};


const StateCentersList = ({ dues, centers }) => {
    const summary = buildStateSummary(dues, centers);
    const [openStates, setOpenStates] = useState({});
    Object.values(summary).forEach((state) => {
        state.centers.sort((a, b) => b.total - a.total);
    });

    const toggleState = (state) => {
        setOpenStates((prev) => ({ ...prev, [state]: !prev[state] }));
    };

    return (
        <div style={{ padding: "20px", fontFamily: "Arial" }}>
            {Object.entries(summary).map(([state, data]) => (
                <div key={state} style={{ marginBottom: "10px" }}>
                    {/* State Row */}
                    <div
                        onClick={() => toggleState(state)}
                        style={{
                            cursor: "pointer",
                            background: "#f0f0f0",
                            padding: "10px",
                            borderRadius: "6px",
                            fontWeight: "bold"
                        }}
                    >
                        {state} — {formatAUD(data.total)}
                    </div>

                    {/* Centers under the state */}
                    {openStates[state] && (
                        <div style={{ marginLeft: "20px", marginTop: "5px" }}>
                            {data.centers.map((center) => (
                                <div
                                    key={center.name}
                                    style={{
                                        padding: "6px 10px",
                                        borderBottom: "1px solid #ddd"
                                    }}
                                >
                                    {center.name} — {formatAUD(center.total)}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default StateCentersList;